import Alert from 'components/Alert';
import styled from 'styled-components';

export const ErrorAlert = styled(Alert)`
  border-radius: 8px;
  width: 100%;
`;

export const IntercomLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;
